module.exports = __webpack_public_path__ + "media/components/assets/icons/star_full-6c44da1add13dcd584b85a1ac49c2a1f.svg";